import * as THREE from "three";

let cameraFeedRenderer: any;
let canvasWidth_: any;
let canvasHeight_: any;
let videoWidth_: any;
let videoHeight_: any;
let texProps: any;
let cubeCamera: any;

export const realtimeReflectionsPipeline = (
  xr8: any,
  scene: any,
  camera: any,
  renderer: any
) => {
  const camTexture_ = new THREE.Texture();

  const renderTarget = new THREE.WebGLCubeRenderTarget(256, {
    format: THREE.RGBFormat,
    generateMipmaps: true,
    minFilter: THREE.LinearMipmapLinearFilter,
    encoding: THREE.sRGBEncoding,
  });

  const refMat = new THREE.MeshBasicMaterial({
    side: THREE.DoubleSide,
    color: 0xffffff,
    map: camTexture_,
  });

  // cubemap scene
  const cubeMapScene = new THREE.Scene();
  cubeCamera = new THREE.CubeCamera(1, 1000, renderTarget);
  const sphere = new THREE.SphereGeometry(100, 15, 15);
  const sphereMesh = new THREE.Mesh(sphere, refMat);
  sphereMesh.scale.set(-1, 1, 1);
  sphereMesh.rotation.set(Math.PI, -Math.PI / 2, 0);
  cubeMapScene.add(sphereMesh);

  const updateSize = ({
    videoWidth,
    videoHeight,
    canvasWidth,
    canvasHeight,
    GLctx,
  }: any) => {
    cameraFeedRenderer = xr8.GlTextureRenderer.create({
      GLctx,
      toTexture: { width: canvasWidth, height: canvasHeight },
      flipY: false,
    });
    canvasWidth_ = canvasWidth;
    canvasHeight_ = canvasHeight;
    videoWidth_ = videoWidth;
    videoHeight_ = videoHeight;
  };

  return {
    name: "realtimeReflectionPipeline",
    onAttach: ({
      videoWidth,
      videoHeight,
      canvasWidth,
      canvasHeight,
      GLctx,
    }: any) => {
      updateSize({ videoWidth, videoHeight, canvasWidth, canvasHeight, GLctx });
    },
    onStart: () => {
      scene.background = camTexture_;
    },
    onUpdate: ({ processCpuResult }: any) => {
      cubeCamera!.update(renderer, cubeMapScene);
      const { reality } = processCpuResult;
      if (!reality) {
        return;
      }
      texProps!.__webglTexture = cameraFeedRenderer.render({
        renderTexture: reality.realityTexture,
        viewport: xr8.GlTextureRenderer.fillTextureViewport(
          videoWidth_,
          videoHeight_,
          canvasWidth_,
          canvasHeight_
        ),
      });
    },
    onDeviceOrientationChange: ({ videoWidth, videoHeight, GLctx }: any) => {
      updateSize({
        videoWidth,
        videoHeight,
        canvasWidth_,
        canvasHeight_,
        GLctx,
      });
    },
    onVideoSizeChange: ({
      videoWidth,
      videoHeight,
      canvasWidth,
      canvasHeight,
      GLctx,
    }: any) => {
      updateSize({ videoWidth, videoHeight, canvasWidth, canvasHeight, GLctx });
    },
    onCanvasSizeChange: ({
      GLctx,
      computeCtx,
      videoWidth,
      videoHeight,
      canvasWidth,
      canvasHeight,
    }: any) => {
      updateSize({ videoWidth, videoHeight, canvasWidth, canvasHeight, GLctx });
    },
    onProcessCpu: ({ frameStartResult }: any) => {
      const { cameraTexture } = frameStartResult;
      // force initialization
      texProps = renderer.properties.get(camTexture_);
      texProps.__webglTexture = cameraTexture;
    },
  };
};
